import instance from '@/utils/instance';

//企业申请
export function postApplyCorporate(data) {
    return instance({
        url: `/webL_api/corporate/acc/applyCorporate`,
        method: 'post',
        data
    });
}

//查询公司类别
export function getCompanyType() {
    return instance({
        url: `/webL_api/corporate/oper/queryCompanyType`,
        method: 'get'
    });
}

//查询来源类别
export function getOriginType() {
    return instance({
        url: `/webL_api/corporate/oper/querySourceType`,
        method: 'get'
    });
}

//查询账号类别
export function getAccountType() {
    return instance({
        url: `/webL_api/corporate/oper/queryAccountType`,
        method: 'get'
    });
}
